import ProgressIndicator from 'components/ProgressIndicator';

import useProgressIndicator from './useProgressIndicator';

import JobBackButton from '../JobBackButton';

const ProgressHeaderIndicator: React.FunctionComponent = function () {
  const { items, showBackButton } = useProgressIndicator();
  return (
    <div className="lg:hidden flex flex-col sticky top-[65px] md:top-[73px] z-50">
      <ProgressIndicator items={items} lastPassed />
      {showBackButton && (
        <div className="flex md:hidden w-full bg-neutral-000 border-b border-neutral-200 py-1.5">
          <JobBackButton />
        </div>
      )}
    </div>
  );
};

export default ProgressHeaderIndicator;
